import React from 'react';
import { HeroSection } from '@/components/sections/HeroSection';
import { InsuranceSection } from '@/components/sections/InsuranceSection';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { AboutSection } from '@/components/sections/AboutSection';
import { ReviewsSection } from '@/components/sections/ReviewsSection';
import { CTASection } from '@/components/sections/CTASection';
import { PartnersSection } from '@/components/sections/PartnersSection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <InsuranceSection />
      <ServicesSection />
      <AboutSection />
      <ReviewsSection />
      <CTASection />
      <PartnersSection />
    </>
  );
};

export default HomePage;
